import { createAsyncSlice } from 'store/createAsyncSlice';
import { createAchPushAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: createAchPushSlice, asyncAction: createAchPushAction } = createAsyncSlice(
  'createAchPushSlice',
  createAchPushAsync
);
